import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setUserOnline } from "../../../services/storage/LocalStorage";
import {
    setBannerVisibility,
    setCounter,
} from "../../../state/actions/offlineBanner";
import OfflineBanner from "./OfflineBanner";
import SlowNetworkBanner from "./SlowNetworkBanner";

let intervalId;

const Banner = () => {
    const dispatch = useDispatch();
    const [slowInternet, setSlowInternet] = useState(false);
    const { show } = useSelector((state) => state.appNotification);
    const latestAPIRequest = useSelector((state) => state.offlineBanner.latestAPIRequest);
    const counter = useSelector((state) => state.offlineBanner.counter);
    const visibility = useSelector((state) => state.offlineBanner.visibility);

    const refreshImages = () => {
        const images = document.querySelectorAll("img");
        images.forEach((img) => {
            const src = img.getAttribute("src");
            if (src) {
                img.src = src.split("?")[0] + `?t=${Date.now()}`;
            }
        });
    };

    const checkSlowConnection = useCallback(() => {
        const connection = navigator.connection;
        if (connection && typeof connection.downlink === "number") {
            if (connection.downlink < 0.5) {
                setSlowInternet(true);
                dispatch(setBannerVisibility(false))
            } else {
                setSlowInternet(false);
                dispatch(setBannerVisibility(false))
            }
        }
    }, []);

    const changeNetworkHandler = useCallback(() => {
        checkSlowConnection();
    }, [checkSlowConnection]);

    const resetCounter = useCallback((visibility, value) => {
        clearInterval(intervalId);
        dispatch(setBannerVisibility(visibility))
            .then(() => {
                return dispatch(setCounter(value));
            })
            .then(() => {
                countdown();
            });
    }, [dispatch]);

    const tick = useCallback(() => {
        if (counter === 0) {
            checkConnection();
        }
        dispatch(setCounter(counter - 1));
    }, [counter, dispatch]);

    const countdown = () => {
        clearInterval(intervalId);
        intervalId = setInterval(tick, 1000);
    };

    const checkConnection = useCallback(() => {
        if (navigator.onLine) {
            if (latestAPIRequest) {
                const {
                    url,
                    request,
                    responseType,
                    requestSerializeFn,
                    responseDeserializeFn,
                    options = {},
                    noSpinner,
                } = latestAPIRequest;

                // Optionally re-fire the last request
            }
            clearInterval(intervalId);
            dispatch(setBannerVisibility(false));
            setUserOnline(true);
        } else {
            resetCounter(true, 5);
            setUserOnline(false);
        }
    }, [latestAPIRequest, dispatch, resetCounter]);

    const handleCloseBanner = () => {
        clearTimeout(intervalId);
        resetCounter(false, 5);
    };

    const closeSlowInternetBanner = () => {
        dispatch(setBannerVisibility(true));
        setSlowInternet(false);
    };

    useEffect(() => {
        const onOffline = () => {
            if (!navigator.onLine) {
                dispatch(setBannerVisibility(true))
                resetCounter(true, 5);
            }
        };

        const onOnline = () => {
            refreshImages();
            if (navigator.onLine) {
                setBannerVisibility(false)
                clearInterval(intervalId);
                dispatch(setBannerVisibility(false)).then(() => {
                    dispatch(setCounter(5));
                });
                window.dispatchEvent(new Event("stream_closed"));
            }
        };

        window.addEventListener("offline", onOffline);
        window.addEventListener("online", onOnline);

        checkSlowConnection();

        if (navigator.connection) {
            navigator.connection.addEventListener("change", changeNetworkHandler);
        }

        return () => {
            clearInterval(intervalId);
            window.removeEventListener("offline", onOffline);
            window.removeEventListener("online", onOnline);
            if (navigator.connection) {
                navigator.connection.removeEventListener("change", changeNetworkHandler);
            }
        };
    }, [checkConnection, checkSlowConnection, changeNetworkHandler, resetCounter, dispatch]);

    useEffect(() => {
        const disableButtons = () => {
            const trash = document.getElementsByClassName("mapbox-gl-draw_trash");
            const polygon = document.getElementsByClassName("mapbox-gl-draw_polygon");
            if (visibility) {
                if (trash.length) trash[0].setAttribute("disabled", "");
                if (polygon.length) polygon[0].setAttribute("disabled", "");
            } else {
                if (trash.length) trash[0].removeAttribute("disabled");
                if (polygon.length) polygon[0].removeAttribute("disabled");
            }
        };
        disableButtons();
    }, [visibility]);

    if (visibility) return <OfflineBanner />;
    if (show) return null; // Placeholder for app banner
    if (!visibility && slowInternet) {
        return <SlowNetworkBanner closeSlowInternetBanner={closeSlowInternetBanner} />;
    }

    return null;
};

export default Banner;
